import styles from "@/styles/viewUserReview.module.scss"
import DefaultLayout from "@/components/DefaultLayout"
import Head from "next/head"
import productApi from '@/service/modules/productApi'
import { useEffect, useState } from "react"
import { Pagination, Image, Rate, Skeleton } from "antd"
import getConfig from 'next/config'
import Link from "next/link";
import { AntDesignOutlined, FacebookOutlined, TwitterOutlined } from "@ant-design/icons"
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

export default function ViewUserReview() {

  const [page, setPage] = useState<number>(1)
  const [prePage, setPrePage] = useState<number>(3)
  const [total, setTotal] = useState<number>(0)
  const [name, setName] = useState<string>('')
  const [userInfo, setUserInfo] = useState<any>({})
  const [reviewList, setReviewList] = useState<any[]>([])
  const [latestList, setLatestList] = useState<any[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  // 获取用户评论列表
  const getUserReview = async () => {
    try {
      const url = window.location.href;

      // 去掉 origin，提取 path 部分
      const path = new URL(url).pathname;

      const segments = path.split('/');

      const userId = parseFloat(segments[3]);
      setLoading(true)
      const params = {
        customerID: userId,
        page: page,
        prePage: prePage
      }
      const res = await productApi.userReview(params)
      const { name, gender, customer: { total, list, facet: { recommend, recommendRate, totalVotes }, stats: { createTime: { min, max } } }, latest } = res.data
      const userObj = {
        age: "",
        gender: gender == -1 ? 'Male' : gender == 0 ? 'Female' : '/',
        reviews: total,
        recommendRate: recommendRate,
        recommended: recommend,
        helpfulVotes: totalVotes,
        activeSince: min,
        lastReview: max
      }
      setUserInfo(userObj)
      setName(name)
      setTotal(total)
      setReviewList(list)
      setLatestList(latest.list)
      setLoading(false)
    } catch (error) {
      console.log(error);
      setLoading(false)

    }
  }

  const pageChange = (page: number) => {
    setPage(page)
  }

  useEffect(() => {
    getUserReview()
  }, [page])
  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals
          & Discounts | CrazySales
        </title>
        <meta
          name="description"
          content="Online shopping reviews by Crazysales customer Clinton Baker in Australia, reviews 1 on Crazysales.com.au."
        ></meta>
      </Head>
      <DefaultLayout>
        <div style={{ padding: 24 }}>
          <div className={styles.container}>
            <div className={styles.header}>
              <div className={styles['header-overlay']}></div>
              <div className={styles['header-content']}>
                <div className={styles['reviewer-info']}>
                  <h1 className={styles['reviewer-title']}>Reviews by {name}</h1>

                  <div className={styles['stats-grid']}>
                    <div className={styles['stat-card']}>
                      <div className={styles['stat-label']}>Age</div>
                      <div className={styles['stat-value']}>{userInfo.age || "-"}</div>
                    </div>
                    <div className={styles['stat-card']}>
                      <div className={styles['stat-label']}>Gender</div>
                      <div className={styles['stat-value']}>{userInfo.gender || "-"}</div>
                    </div>
                    <div className={styles['stat-card']}>
                      <div className={styles['stat-label']}>Reviews</div>
                      <div className={styles['stat-value']}>{userInfo.reviews || "-"}</div>
                    </div>
                    <div className={styles['stat-card']}>
                      <div className={styles['stat-label']}>Recommend rate</div>
                      <div className={styles['stat-value']}>{userInfo.recommendRate || "-"}</div>
                    </div>
                  </div>

                  <div className={styles['stats-grid']}>
                    <div className={styles['stat-card']}>
                      <div className={styles['stat-label']}>Recommended</div>
                      <div className={styles['stat-value']}>{userInfo.recommended || "-"}</div>
                    </div>
                    <div className={styles['stat-card']}>
                      <div className={styles['stat-label']}>Helpful Votes</div>
                      <div className={styles['stat-value']}>{userInfo.helpfulVotes || "-"}</div>
                    </div>
                    <div className={styles['stat-card']}>
                      <div className={styles['stat-label']}>Active Since</div>
                      <div className={styles['stat-value']}>{userInfo.activeSince || "-"}</div>
                    </div>
                    <div className={styles['stat-card']}>
                      <div className={styles['stat-label']}>Last Review</div>
                      <div className={styles['stat-value']}>{userInfo.lastReview || "-"}</div>
                    </div>
                  </div>
                </div>

                <div className={styles['reviewer-avatar']}>
                  <Image
                    src={`${imageDomain}/svg/model-photos.svg`}
                    width={112}
                    height={112}
                    alt="Reviewer Avatar"
                    preview={false}
                  />
                </div>
              </div>
            </div>

            <div className={styles['main-content']}>
              <h2 className={styles['section-title']}>
                Featured Reviews
              </h2>

              {
                loading
                  ?
                  <Skeleton active paragraph={{ rows: 5 }} />
                  :
                  <div className={styles['reviews-container']}>
                    {reviewList.map((item: any) => (
                      <div className={styles['review-card']} key={item.reviewID}>
                        {
                          !!(item.product && item.product.newSmallPicture)
                          &&
                          <div className={styles['product-image']}>
                            <Image
                              src={item.product.newSmallPicture}
                              alt={item.title}
                            />
                            <Link href={item.product.url} legacyBehavior>
                              <a className={styles['product-title']} rel="noopener noreferrer" target={"_blank"}>
                                {item.product.name}
                              </a>
                            </Link>
                          </div>
                        }
                        <div className={styles['review-content']}>
                          <div className={styles['review-header']}>
                            <div className={styles['review-title']}>
                              {item.title}
                            </div>
                            <div className={styles['review-date']}>{new Date(item.createTime).toLocaleString()}</div>
                          </div>
                          <div className={styles['review-text']}>
                            <div>{item.detail}</div>
                            {
                              !!(item.images && item.images.length > 0)
                              &&
                              <div className={styles['reviewModule__footer']}>
                                <Image
                                  src={item.images}
                                  width={150}
                                  height={150}
                                  alt={item.title}
                                />
                              </div>
                            }
                          </div>
                          <div className={styles['review-footer']}>
                            <div className={styles['helpful-count']}>
                              <i className="fas fa-thumbs-up"></i> {item.rate} of {item.totalVotes} found this helpful
                            </div>
                            {/* <div className={styles['recommend-tag']}>
                          <i className="fas fa-check-circle"></i> Recommend the product? Yes
                        </div> */}
                            <div className={styles['share-buttons']}>
                              <Link
                                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
                                legacyBehavior
                              >
                                <a className={styles['share-btn']} target="_blank" rel="noopener noreferrer">
                                  <FacebookOutlined />
                                </a>
                              </Link>
                              <Link
                                href={`http://digg.com/submit?phase=2&url=${encodeURIComponent(window.location.href)}`}
                                legacyBehavior
                              >
                                <a className={styles['share-btn']} target="_blank" rel="noopener noreferrer">
                                  <AntDesignOutlined />
                                </a>
                              </Link>
                              <Link
                                href={`http://twitter.com/home?status=I%20like%20this%20on%20@crayzsales%20${encodeURIComponent(window.location.href)}`}
                                legacyBehavior
                              >
                                <a className={styles['share-btn']} target="_blank" rel="noopener noreferrer">
                                  <TwitterOutlined />
                                </a>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
              }

              <div style={{ display: 'flex', justifyContent: 'end', marginTop: 24 }}>
                <Pagination simple current={page} pageSize={prePage} total={total} onChange={pageChange} />
              </div>

              <h2 className={styles['section-title']}>
                Latest Customer Reviews
              </h2>

              <div className={styles['reviewModule__grid']}>
                {
                  latestList.map((item: any) => (
                    <div className={styles['reviewModule__card']} key={item.reviewID}>
                      <div className={styles['reviewModule__product']}>
                        {
                          !!(item.product && item.product.newSmallPicture)
                          &&
                          <div className={styles['product-image']} style={{ background: '#fff' }}>
                            <Link href={item.product.url} legacyBehavior>
                              <a rel="noopener noreferrer" target={"_blank"}>
                                <Image
                                  src={item.product.newSmallPicture}
                                  alt={item.title}
                                  preview={false}
                                />
                              </a>
                            </Link>
                            <Link href={item.product.url} legacyBehavior>
                              <a className={styles['product-title']} rel="noopener noreferrer" target={"_blank"}>
                                {item.product.name}
                              </a>
                            </Link>
                          </div>
                        }
                      </div>
                      <div style={{ flex: 1, padding: 20 }}>
                        <div className={styles['reviewModule__headerWrapper']}>
                          <div className={styles['reviewModule__reviewer']}>
                            <div className={styles['reviewModule__avatar']}>
                              <Image
                                src={`${imageDomain}/svg/model-photos.svg`}
                                width={52}
                                height={52}
                                alt="Reviewer Avatar"
                                preview={false}
                              />
                            </div>
                            <div className={styles['reviewModule__reviewerInfo']}>
                              <div className={styles['reviewModule__name']}>{item.customerName}</div>
                              <div className={styles['reviewModule__date']}>{new Date(item.createTime).toLocaleString()}</div>
                            </div>
                          </div>
                          <div className={styles['reviewModule__rating']}>
                            <div className={styles['reviewModule__ratingValue']}>
                              {/* <Rate value={item.rate} disabled /> */}
                            </div>
                          </div>
                        </div>
                        {
                          item.title
                          &&
                          <h3 className={styles['reviewModule__titleText']}>{item.title}</h3>
                        }
                        <p className={styles['reviewModule__content']}>
                          {item.detail}
                        </p>

                        {
                          !!(item.images && item.images.length > 0)
                          &&
                          <div className={styles['reviewModule__footer']}>
                            <Image
                              src={item.images}
                              width={150}
                              height={150}
                              alt={item.title}
                            />
                          </div>
                        }
                      </div>
                    </div>
                  ))
                }


              </div>

            </div>
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}